import { render, staticRenderFns } from "./tenant-info.vue?vue&type=template&id=4b454b64&scoped=true"
import script from "./tenant-info.vue?vue&type=script&lang=js"
export * from "./tenant-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b454b64",
  null
  
)

export default component.exports